const EDIT_TAGS = 'edit_tags';
const EDIT_CUSTOM_TAGS = 'edit_custom_tags';
const EXPORT_TRANSCRIPT_CALLS = 'export_transcript_calls';

export { EDIT_TAGS, EDIT_CUSTOM_TAGS, EXPORT_TRANSCRIPT_CALLS };
